import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { scrollIntoView } from '../../utilities/behavior-helpers/index.js';
import '../../utilities/dom-helpers/index.js';
import { lineClamp } from '../../utilities/text-helpers/index.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import css_248z from './category-tile-big.scss.js';

const headlineCharLimit = 80;
const bodyCharLimit = 120;
class CategoryTileBig extends s {
    constructor() {
        super();
        this.onHoverBg = false;
        this.ctaButton = null;
        this._query = '(max-width: 1365px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    setHover() {
        var _a;
        if (this._isMobile)
            return;
        (_a = this.ctaButton) === null || _a === void 0 ? void 0 : _a.classList.add('hovered');
    }
    unsetHover() {
        var _a;
        (_a = this.ctaButton) === null || _a === void 0 ? void 0 : _a.classList.remove('hovered');
    }
    handleTabKey(e) {
        if (e.key === 'Tab') {
            scrollIntoView(this, document.querySelector('.container > .top'), 50);
        }
    }
    firstUpdated() {
        this.ctaButton = this.querySelector('.primary-button');
        this.addEventListener('keyup', e => this.handleTabKey(e));
        const sectionTitle = this.querySelector('section-title');
        const headline = sectionTitle === null || sectionTitle === void 0 ? void 0 : sectionTitle.querySelector('[slot="headline"]');
        const bodyText = sectionTitle === null || sectionTitle === void 0 ? void 0 : sectionTitle.querySelector('[slot="body-text"]');
        if (headline)
            headline.innerText = lineClamp(headline.innerText, headlineCharLimit);
        if (bodyText)
            bodyText.innerText = lineClamp(bodyText.innerText, bodyCharLimit);
    }
    render() {
        return x `<lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query><div class="big-tile ${o({
            'style-hover': this.onHoverBg,
            'big-tile--mobile': this._isMobile,
        })}" @focus="${this.setHover}" @blur="${this.unsetHover}" @mouseover="${this.setHover}" @mouseleave="${this.unsetHover}"><slot name="background-image"></slot><slot name="desktop-content" class="desktop-content"><slot name="date"></slot><slot name="tags" class="tags"></slot><slot name="headings"></slot></slot><div class="mobile-content"><slot name="mobile-heading"></slot><slot name="secondary-cta"></slot></div></div>`;
    }
}
CategoryTileBig.styles = css_248z;
__decorate([
    n({ type: Boolean })
], CategoryTileBig.prototype, "onHoverBg", void 0);
customElements.define('category-tile-big', CategoryTileBig);

export { CategoryTileBig };
